import React, { createContext, useContext, useState } from "react";
import { IAuthData } from "./model/dto";
import { getAuthDataFromLocalStorage } from "./model/auth-utils";

interface AuthContextType {
  authData: IAuthData;
  isAuthenticated: boolean;
  termsAccepted: boolean;
  setAuthData: (data: IAuthData) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  authData: {} as IAuthData,
  isAuthenticated: false,
  termsAccepted: false,
  setAuthData: () => {},
  logout: () => {},
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [authData, setAuthDataState] = useState<IAuthData>(getAuthDataFromLocalStorage());
  const isAuthenticated = Boolean(authData?.accessToken);
  const termsAccepted = Boolean(authData?.terms);

  const setAuthData = (data: IAuthData) => {
    localStorage.setItem("authData", JSON.stringify(data));
    setAuthDataState(data);
  };

  const logout = () => {
    localStorage.removeItem("authData");
    setAuthDataState({} as IAuthData);
  };

  return (
    <AuthContext.Provider value={{ authData, isAuthenticated, termsAccepted, setAuthData, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext); 